// extracted by mini-css-extract-plugin
export default {"form":"review_position-module___form___b753108a"};